import { PondereModalComponent } from "./pondere-modal/pondere-modal.component";
import { NgbdModalConfirm } from "./../../services/modal-confirm";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ParametrePondere } from "./../../models/ParametrePondere";
import { FondsPropresService } from "./../../services/fonds-propres.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-parametre-pondere",
  templateUrl: "./parametre-pondere.component.html",
  styleUrls: ["./parametre-pondere.component.scss"],
})
export class ParametrePondereComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<ParametrePondere>;
  isLoadingResults = true;

  displayedColumns = [
    "id",
    "codeSegmentPrudentiel",
    "libelleEntity",
    "codeRule",
    "devise",
    "isActive",
    "zoneRegionale",
    "tailleProvision",
    "ponderation",
    "actions",
  ];
  data: ParametrePondere[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getParametrePonderes();
  }

  getParametrePonderes() {
    this.shared.getParametrePonderes().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  //row in modal popup
  EditerParametrePondere(row, activite) {
    const modalRef = this.modalService.open(PondereModalComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "my-app-modal-class",
    });
    modalRef.componentInstance.parametrePondere = row;
    modalRef.componentInstance.title = "Mise à jour de paramètre ponderé";
    if (activite == "add") {
      modalRef.componentInstance.title = "Ajout de paramètre ponderé";
    }

    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getParametrePonderes();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  //delete specific import
  SupprimerParametrePondere(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.codeSegmentPrudentiel;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer ce paramètre";
    modalConfirmRef.componentInstance.description =
      '<p>Toutes les informations de ce paramètre seront définitivement supprimées. <span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        console.log("modalConfirmRefResult", result);
        // on close
        this.isLoadingResults = true;
        this.shared.SupprimerParametrePondere(row.id).subscribe(
          (data) => {
            console.log(data);
            this.getParametrePonderes();
          },
          (error) => {
            this.isLoadingResults = false;
          },
          () => {
            this.isLoadingResults = false;
          }
        );
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }
}
